import { useEffect } from "react";
import IMeeting from "../../api/IMeeting";
import CONSTANTS from "../../contracts/Constants";
import { useMeetingStore } from "../../stores/useMeetingStore";
import stringify, { toString } from "../../utilities/stringify";
import useHubConnection from "./useHubConnection";

type UseMeetingChangeSocket = {
    meetingId: string;
};

const useMeetingChangeSocket = ({ meetingId }: UseMeetingChangeSocket) => {
    const setMeeting = useMeetingStore((state) => state.setMeeting);

    const hubConnectionRef = useHubConnection(
        CONSTANTS.SocketUrl + `?meetingId=${meetingId}`,
        (hubConnection) => {
            hubConnection.on("MeetingChanged", onMeetingChange);
            
            // ?????????
            console.log(`Setting up SignalR listeners for meeting: ${meetingId}`);
        }
    );

    const onMeetingChange = (changedId: string, newMeeting: IMeeting) => {
        console.log(`MeetingChanged event received for meeting: ${changedId}`);
        
        if (meetingId !== changedId) {
            console.warn(`Meeting ID mismatch. Expected: ${meetingId}, Received: ${changedId}`);
            return;
        }

        console.log(`Updating meeting state with new data:`, {
            votingRound: newMeeting.votingRound,
            votingOn: newMeeting.votingOn,
            participantsCount: newMeeting.participants?.length
        });

        setMeeting(newMeeting);
    };

    // ????
    useEffect(() => {
        return () => {
            console.log(`Cleaning up SignalR listeners for meeting: ${meetingId}`);
        };
    }, [meetingId]);

    return;
};

export default useMeetingChangeSocket;
